import React from "react";
import SearchingIcon from "../Defaults/SearchingIcon";

const Searching = ({ provider }) => {
    return (
        <div className="searching-icon-container">
            <SearchingIcon />
        </div>
    );
};

export default Searching;
